// extracted by mini-css-extract-plugin
module.exports = {"popupWrapper":"DownloadFilePopup__popupWrapper___3fzs8","popupMessage":"DownloadFilePopup__popupMessage___2BR1R","popupButton":"DownloadFilePopup__popupButton___UlEHJ"};